module.exports = __webpack_public_path__ + "img/fl.f54d4881.svg";